import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import SelectNumberInput from './SelectNumberInput';
import NumberInput from './NumberInput';
import SelectInput from './SelectInput';
import { SummaryWrapper, SummaryWrapperNumber } from './SummaryWrapper';

import { countLeasingPrice } from '../../utils/calculator';

class CalculatorLeasing extends React.Component {
    state = {
        summary: '',
        a: parseFloat(this.props.rentLong.a),
        b: parseFloat(this.props.rentLong.b),
        c: parseFloat(this.props.rentLong.c),
        d: this.props.rentLong.d
            ? parseFloat(this.props.rentLong.d)
            : parseFloat(this.props.defaultCarPrice),
        ...this.props.defaultValues
    };

    componentDidMount() {
        this.props.onChange('CalculatorLeasing', this.state);
    }

    onChange = (inputName, values) => {
        this.setState(
            {
                [inputName]: _.get(values, 'value', values)
            },
            () => {
                const summary = countLeasingPrice(this.state);
                this.setState(
                    {
                        summary: summary ? summary : ''
                    },
                    () => {
                        this.props.onChange('CalculatorLeasing', this.state);
                    }
                );
            }
        );
    };

    render() {
        const { disableCarValue, defaultCarPrice, rentLong } = this.props;

        return (
            <>
                <NumberInput
                    name="d"
                    disabled={disableCarValue}
                    defaultValue={defaultCarPrice}
                    onChange={this.onChange}
                    title="Sugerowana wartość katalogowa"
                    value={this.state.d}
                />
                <SelectNumberInput
                    selectData={rentLong.e}
                    name="e"
                    onChange={this.onChange}
                    title="Wpłata własna"
                    value={this.state.e}
                />
                <NumberInput
                    name="g"
                    onChange={this.onChange}
                    title="Wartość wykupu"
                    value={this.state.g}
                />
                <SelectInput
                    name="f"
                    onChange={this.onChange}
                    selectData={rentLong.f}
                    selected={this.state.f}
                    title="Okres umowy (miesięcy)"
                />
                {this.state.summary && (
                    <SummaryWrapper>
                        <label>Rata netto</label>
                        <SummaryWrapperNumber>
                            <NumberInput
                                summary
                                displayType="text"
                                value={this.state.summary}
                            />
                            <span>/mies.</span>
                            <button
                                className="btn-general btn-general--primary"
                                onClick={this.props.showModal}
                            >
                                Dalej
                            </button>
                        </SummaryWrapperNumber>
                    </SummaryWrapper>
                )}
            </>
        );
    }
}

CalculatorLeasing.propTypes = {
    rentLong: PropTypes.shape({
        a: PropTypes.string.isRequired,
        b: PropTypes.string.isRequired,
        c: PropTypes.string.isRequired,
        f: PropTypes.arrayOf(PropTypes.string.isRequired).isReqired,
        h: PropTypes.arrayOf(PropTypes.string.isRequired).isReqired
    }).isRequired
};

export default CalculatorLeasing;
